import type { ReactNode } from 'react';

export const symbol_hide: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M376-334 183-141q-9 9-21 9t-21-8.84q-9-8.84-9-21t9-21.16l193-193h-88q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h160q12.75 0 21.38 8.62Q436-418.75 436-406v160q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-88Zm251-251h88q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H555q-12.75 0-21.37-8.63Q525-542.25 525-555v-160q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v88l192-192q9-9 21-9t21 8.84q9 8.84 9 21T819-777L627-585Z"
		/>
	</svg>
);
